import axios from "axios";

class ApiManager {
  get(url, api_key = undefined) {
    let headers = {};

    if (api_key != undefined) {
      headers["x-api-key"] = api_key;
    }
    return axios.get(url, headers);
  }

  post(url, body, configuration) {
    const { api_key, token } = configuration;
    const headers = {};

    if (token != undefined) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    if (api_key != undefined) {
      headers["x-api-key"] = api_key;
    }
    return axios.post(url, body, {
      headers,
    });
  }
}

export default ApiManager;
